export const ADD_ARTICLE = "ADD_ARTICLE";
export const ADD_NAME = "ADD_NAME";
export const IS_AUTHENTICATE = "IS_AUTHENTICATE";